import React, { useEffect } from 'react';
import { Form } from 'informed';
import { useWindowSize } from '@magento/peregrine/lib/hooks/useWindowSize';
import { isRequired } from '@magento/venia-ui/lib/util/formValidators';
import TextInput from '@magento/venia-ui/lib/components/TextInput';
import { Button, TextArea, CheckBox } from 'src/components';
import { useResources } from './useResources';
import Field from '../../overrides/venia-ui/components/Field';
import CustomSelect from '../../components/CustomSelect';
import useToast from '../../hooks/useToast';

var RequestRevitForm = function RequestRevitForm() {
  var _useToast = useToast(),
      addMessage = _useToast.addMessage;

  var options = [{
    label: 'Admin',
    value: 'Admin'
  }];
  var fileTypeOptions = [{
    label: 'CAD',
    value: 'Cad'
  }, {
    label: 'REVIT',
    value: 'Revit'
  }, {
    label: 'PDF',
    value: 'Pdf'
  }, {
    label: 'DOC',
    value: 'Doc'
  }, {
    label: 'IMAGE',
    value: 'Image'
  }];

  var _useWindowSize = useWindowSize(),
      innerWidth = _useWindowSize.innerWidth;

  var isSmallDevice = innerWidth < 640;

  var _useResources = useResources(),
      handleSubmitRequestResources = _useResources.handleSubmitRequestResources,
      setFormApi = _useResources.setFormApi,
      requestResourcesResponse = _useResources.requestResourcesResponse;

  useEffect(function () {
    requestResourcesResponse && addMessage('success', 'Resource Request Successfully Sent');
  }, [requestResourcesResponse]);
  return React.createElement("div", {
    className: "w-full"
  }, React.createElement(Form, {
    getApi: setFormApi,
    className: "grid grid-cols-1 sm_grid-cols-12 sm_gap-5",
    onSubmit: function onSubmit(data) {
      return handleSubmitRequestResources(data);
    }
  }, React.createElement("div", {
    className: "col-span-1 order-1 sm_col-start-2 sm_col-span-5 mb_5 sm_mb-14 grid grid-cols-1 gap-y-5"
  }, React.createElement(Field, {
    id: "company",
    label: "company"
  }, React.createElement(TextInput, {
    field: "company",
    id: "company",
    placeholder: "Your company *",
    autoComplete: "company",
    mode: isSmallDevice ? 'dark' : 'light',
    type: "text",
    classes: {},
    validate: isRequired
  })), React.createElement(Field, {
    id: "firstName",
    label: "firstName"
  }, React.createElement(TextInput, {
    field: "firstName",
    id: "firstName",
    placeholder: "First Name *",
    mode: isSmallDevice ? 'dark' : 'light',
    type: "text",
    classes: {},
    validate: isRequired
  })), React.createElement(Field, {
    id: "lastName",
    label: "lastName"
  }, React.createElement(TextInput, {
    field: "lastName",
    id: "lastName",
    placeholder: "Last Name *",
    mode: isSmallDevice ? 'dark' : 'light',
    type: "text",
    classes: {},
    validate: isRequired
  }))), React.createElement("div", {
    className: "col-span-1 order-3 sm_order-2  sm_col-start-7 sm_col-span-5 mb_5 sm_mb-14 grid grid-cols-1 gap-y-5"
  }, React.createElement(Field, {
    id: "role",
    label: "Role"
  }, React.createElement(CustomSelect, {
    required: true,
    options: options,
    isSearchable: false,
    field: 'role',
    id: "role",
    placeholder: 'Your Role *'
  })), React.createElement(Field, {
    id: "email",
    label: "email"
  }, React.createElement(TextInput, {
    field: "email",
    id: "email",
    placeholder: "Email *",
    mode: isSmallDevice ? 'dark' : 'light',
    type: "email",
    classes: {},
    validate: isRequired
  })), React.createElement(Field, {
    id: "zip",
    label: "zip"
  }, React.createElement(TextInput, {
    field: "zip",
    id: "zip",
    placeholder: "Zipcode/Postal Code *",
    type: "text",
    mode: isSmallDevice ? 'dark' : 'light',
    classes: {},
    validate: isRequired
  }))), React.createElement("div", {
    className: "order-2 sm_order-3 col-span-1 sm_col-start-2 sm_col-span-5 mb_5 sm_mb-14 grid grid-cols-1 gap-y-5"
  }, React.createElement(Field, {
    id: "projectName",
    label: "projectName"
  }, React.createElement(TextInput, {
    field: "projectName",
    id: "projectName",
    placeholder: "Project Name *",
    mode: isSmallDevice ? 'dark' : 'light',
    type: "text",
    classes: {},
    validate: isRequired
  })), React.createElement(Field, {
    id: "message",
    label: "message"
  }, React.createElement(TextArea, {
    field: "message",
    id: "message",
    validate: isRequired,
    placeholder: "Message *",
    mode: isSmallDevice ? 'dark' : 'light',
    classes: {}
  }))), React.createElement("div", {
    className: "order-4 col-span-1 sm_col-start-7 sm_col-span-5 mb-14 grid grid-cols-1 gap-y-5"
  }, React.createElement(Field, {
    id: "fileType",
    label: "Specify File Type"
  }, React.createElement(CustomSelect, {
    required: true,
    options: fileTypeOptions,
    field: 'fileType',
    id: "fileType",
    placeholder: 'Specify File Type *'
  })), React.createElement(Field, {
    id: "baseItem",
    label: "baseItem"
  }, React.createElement(TextInput, {
    field: "baseItem",
    id: "baseItem",
    placeholder: "Base Item # *",
    mode: isSmallDevice ? 'dark' : 'light',
    type: "text",
    classes: {},
    validate: isRequired
  })), React.createElement(CheckBox, {
    field: "consentCollectData",
    type: "check",
    mode: isSmallDevice ? 'dark' : 'light',
    label: "I consent to my submitted data being collected and stored. *",
    validate: isRequired
  })), React.createElement("div", {
    className: "order-5 col-span-1 sm_col-start-9 sm_col-span-3 mb-20"
  }, React.createElement(Button, {
    type: "submit",
    priority: isSmallDevice ? 'high' : 'normal',
    "aria-label": "Send",
    fullWidth: true
  }, "SEND"))));
};

export default RequestRevitForm;